import { useForm } from 'react-hook-form';
import StyledFormSection from '../styled/StyledFormSection';
import { YesNoStyledRadioGroup } from '../styled/StyledRadioGroup';
import { Label } from '../ui/label';
import { useUpdateShouldShareAllCircuits } from '@/api/user.api';
import { useTranslation } from '@/i18n';

const DistributorsSettingsSection = ({
  shouldShareAllCircuits,
}: {
  shouldShareAllCircuits: boolean;
}) => {
  const { t } = useTranslation();
  const { control } = useForm<{
    shouldShareAllCircuits?: 'true' | 'false';
  }>({
    mode: 'onChange',
    defaultValues: {
      shouldShareAllCircuits: shouldShareAllCircuits ? 'true' : 'false',
    },
  });

  const { mutateAsync: updateShouldShareAllCircuits } =
    useUpdateShouldShareAllCircuits();

  return (
    <StyledFormSection
      sectionTitle={t('distributors.settings.title')}
      isExpandable
    >
      <Label className="text-gray-700">
        {t('distributors.settings.shareAllCircuitsQuestion')}
        <YesNoStyledRadioGroup
          name="shouldShareAllCircuits"
          control={control}
          customOnChange={(value) =>
            updateShouldShareAllCircuits(value === 'true')
          }
        />
      </Label>
    </StyledFormSection>
  );
};

export default DistributorsSettingsSection;
